"use client"
import { useState, useEffect } from "react"

const CountDownTimer = ({ expiredAt, onExpire }) => {
  const [fixedExpiredAt] = useState(
    expiredAt || new Date(Date.now() + 3600 * 1000).toISOString()
  )

  const parseTimestamp = (timestamp) => {
    return Math.floor(new Date(timestamp).getTime() / 1000)
  }

  const calculateTimeLeft = () => {
    const now = Math.floor(Date.now() / 1000)
    const difference = parseTimestamp(fixedExpiredAt) - now

    if (difference <= 0) {
      return { hours: 0, minutes: 0, seconds: 0, expired: true }
    }

    return {
      hours: Math.floor(difference / 3600),
      minutes: Math.floor((difference % 3600) / 60),
      seconds: difference % 60,
      expired: false,
    }
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        const now = Math.floor(Date.now() / 1000)
        const difference = parseTimestamp(fixedExpiredAt) - now

        if (difference <= 0) {
          clearInterval(timer)
          if (!prevTimeLeft.expired && onExpire) {
            onExpire() // Memanggil callback ketika timer habis
          }
          return { hours: 0, minutes: 0, seconds: 0, expired: true }
        }

        return {
          hours: Math.floor(difference / 3600),
          minutes: Math.floor((difference % 3600) / 60),
          seconds: difference % 60,
          expired: false,
        }
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [fixedExpiredAt, onExpire])

  return (
    <span style={{ color: timeLeft.expired ? "red" : "black", fontWeight: timeLeft.expired ? "bold" : "normal" }}>
      {timeLeft.expired ? "EXPIRED" : 
        `${String(timeLeft.hours).padStart(2, "0")}:
         ${String(timeLeft.minutes).padStart(2, "0")}:
         ${String(timeLeft.seconds).padStart(2, "0")}`}
    </span>
  )
}

export default CountDownTimer;
